import React from "react";
import { useQuery, useMutation } from "@apollo/client";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { Formik } from "formik";
import { toast } from "react-toastify";

import { Dimmer, Card } from "tabler-react";

import * as Yup from "yup";

import {
    GET_SYSTEM_SETTINGS_QUERY,
    UPDATE_SYSTEM_SETTING,
} from "../../queries";
import SettingsBase from "../../SettingsBase";
import SettingsIntegrationTelegramForm from "./SettingsIntegrationTelegramForm";

const TELEGRAM_SCHEMA = Yup.object().shape({
    telegram_bot_token: Yup.string().required(),
    telegram_bot_username: Yup.string(),
});

function SettingsIntegrationTelegram({ t, match, history }) {
    const headerSubTitle = t("settings.integration.title");
    const cardTitle = t("settings.integration.telegram.title");
    const sidebarActive = "integration";

    const {
        loading: loadingToken,
        error: errorToken,
        data: dataToken,
    } = useQuery(GET_SYSTEM_SETTINGS_QUERY, {
        variables: {
            setting: "integration_telegram_bot_token",
        },
    });

    const {
        loading: loadingUsername,
        error: errorUsername,
        data: dataUsername,
    } = useQuery(GET_SYSTEM_SETTINGS_QUERY, {
        variables: {
            setting: "integration_telegram_bot_username",
        },
    });

    const [updateSettings] = useMutation(UPDATE_SYSTEM_SETTING);

    const loading = loadingToken || loadingUsername;
    const error = errorToken || errorUsername;

    if (loading) {
        return (
            <SettingsBase
                headerSubTitle={headerSubTitle}
                cardTitle={cardTitle}
                sidebarActive={sidebarActive}
            >
                <Card.Body>
                    <Dimmer active={true} loader={true}></Dimmer>
                </Card.Body>
            </SettingsBase>
        );
    }
    if (error) {
        return (
            <SettingsBase
                headerSubTitle={headerSubTitle}
                cardTitle={cardTitle}
                sidebarActive={sidebarActive}
            >
                <Card.Body>{t("settings.general.error_loading")}</Card.Body>
            </SettingsBase>
        );
    }

    let telegramBotToken = "";
    let telegramBotUsername = "";

    if (dataToken && dataToken.systemSettings.edges.length) {
        telegramBotToken = dataToken.systemSettings.edges[0].node.value;
    }

    if (dataUsername && dataUsername.systemSettings.edges.length) {
        telegramBotUsername = dataUsername.systemSettings.edges[0].node.value;
    }

    return (
        <SettingsBase
            headerSubTitle={headerSubTitle}
            cardTitle={cardTitle}
            sidebarActive={sidebarActive}
        >
            <Formik
                initialValues={{
                    telegram_bot_token: telegramBotToken,
                    telegram_bot_username: telegramBotUsername,
                }}
                validationSchema={TELEGRAM_SCHEMA}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        // Update bot token
                        await updateSettings({
                            variables: {
                                input: {
                                    setting: "integration_telegram_bot_token",
                                    value: values.telegram_bot_token,
                                },
                            },
                        });

                        // Update bot username
                        await updateSettings({
                            variables: {
                                input: {
                                    setting:
                                        "integration_telegram_bot_username",
                                    value: values.telegram_bot_username,
                                },
                            },
                        });

                        toast.success(
                            t("settings.general.toast_edit_success"),
                            {
                                position: toast.POSITION.BOTTOM_RIGHT,
                            },
                        );
                        setSubmitting(false);
                    } catch (error) {
                        toast.error(t("general.toast_server_error") + error, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                        console.log(
                            "there was an error sending the query",
                            error,
                        );
                        setSubmitting(false);
                    }
                }}
            >
                {({ isSubmitting, errors, values }) => (
                    <SettingsIntegrationTelegramForm
                        isSubmitting={isSubmitting}
                        errors={errors}
                        values={values}
                    />
                )}
            </Formik>
        </SettingsBase>
    );
}

export default withTranslation()(withRouter(SettingsIntegrationTelegram));
